module.exports = __webpack_public_path__ + "img/page-19.ec70ad43.jpg";